import {
  Injectable
} from '@angular/core';
import {
  Observable
, 
  BehaviorSubject
, 
  Subscription
} from 'rxjs';
import {
  ApiService
} from '../services/api';
import {
  HttpParams
} from '@angular/common/http';
import {
  GridDataResult
} from '@progress/kendo-angular-grid';

@Injectable()
export class AccountsService extends BehaviorSubject<GridDataResult> {
  public subscription: Subscription;

  constructor(private api: ApiService) {
    super((<GridDataResult>{
      data: [],
      total: 0
    }));
  }

  public getList(page: number, limit: number, cb: any, search?: string) {
    const params = new HttpParams()
    .set('page', page.toLocaleString())
    .set('limit', limit.toString())
    .set('search', search);

    this.subscription = this.api.get<GridDataResult>('/account', params)
      .subscribe(result => {
        super.next(result);
      });
  }
}
